import { Component, Input } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { QuestionnaireAnswers } from '@enums/questionnaire-answers';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { SelectableOption } from '@models/selectable-option';

@Component({
  selector: 'app-peptide-therapy',
  imports: [UpsellCardComponent],
  templateUrl: './peptide-therapy.component.html',
})
export class PeptideTherapyComponent {
  @Input() public htmlTitle: string = '';
  @Input() public question: string = '';
  @Input() public options: SelectableOption[] = [
    new SelectableOption(
      'Add BPC-157 - Promotes tissue repair and healthier blood flow for firmer erections.',
      UpsellSlugs.PeptideBPC157,
    ),
    new SelectableOption(
      'Add CJC-1295/Ipamorelin - Supports recovery, energy, metabolism, and erection quality.',
      UpsellSlugs.PeptideCJC1295Ipamorelin,
    ),
    new SelectableOption(
      'Add GHK-Cu - Boosts circulation, healing, and overall sexual vitality.',
      UpsellSlugs.PeptideGHKCu,
    ),
    new SelectableOption(
      "No, I don't want to try Peptide Therapy at this time. Most patients try one or more in combination with ED treatment.",
      QuestionnaireAnswers.No,
    ),
  ];
  public readonly slug: UpsellSlugs = UpsellSlugs.PeptideGHKCu;
}
